import React from 'react'
import Lang from '@components/Lang/Lang'
import { Tabs, Badge,} from 'antd'
import CommonBreadcrumb from "@components/CommonBreadcrumb"
import ToBeTransferTable from "./table/ToBeTransferTable";
import TransferringTable from "./table/TransferringTable.js";

class Transfer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            waitIntoNum: "",
            tabKay: 'wait',
        }
    }
    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            // if(key=="wait"){
            //     this.onPageChildOne.pageFetch()
            // }else {
            //     this.onPageChildTwo.pageFetch()
            // }
        })
    }
    changeNum(waitAllocateCount,allocatingCount){
        this.setState({
            waitAllocateCount: waitAllocateCount,
            allocatingCount: allocatingCount,
        } )
    } ;
    render() {
        const { waitAllocateCount,allocatingCount,tabKay } = this.state;
        return (
            <div>
                <CommonBreadcrumb list={[
                    {name: Lang({id: 'DiaoBo', default: '调拨'})},
                ]}></CommonBreadcrumb>
                <div className="customer-screen">
                    <Tabs defaultActiveKey="wait" onChange={this.tabsOnChange.bind(this)}
                          items={[
                              {
                                  key: 'wait',
                                  label:(<div>
                                    <span className="mr_4">
                                            {Lang({id: 'DaiDiaoBo', default: '待调拨'})}
                                    </span>
                                      <Badge count={waitAllocateCount}></Badge>
                                  </div>),
                                  // children:
                              },
                              {
                                  key: 'into',
                                  label:(<div>
                                    <span className="mr_4">
                                            {Lang({id: 'DiaoBoZhong', default: '调拨中'})}
                                    </span>
                                      <Badge count={allocatingCount}></Badge>
                                  </div>),
                                  // children:
                              }
                          ]}
                    />
                        {tabKay=="wait"?<ToBeTransferTable changeNum={(waitAllocateCount,allocatingCount) => {
                                               this.changeNum(waitAllocateCount,allocatingCount);//	待调拨总数
                                           }} />:<TransferringTable changeNum={(waitAllocateCount,allocatingCount) => {
                                                                        this.changeNum(waitAllocateCount,allocatingCount);//	待调拨总数
                                                                    }} />}

                </div>
            </div>
        )
    }
}

export default Transfer
